import Vue from 'vue';
import buttonComponent from 'shared/components/ui/Button';
import inputComponent from 'shared/components/ui/Input';
import formComponent from 'shared/components/ui/Form';
import phoneNumberInputComponent from 'shared/components/ui/PhoneNumberInput';
import dadataComponent from 'shared/components/ui/Dadata';
import initDialogPlugin from 'shared/components/ui/Dialog/dialogPlugin';
import loaderComponent from 'shared/components/ui/Loader';
import checkboxComponent from 'shared/components/ui/Checkbox';

Vue.use(formComponent);
Vue.use(inputComponent);
Vue.use(buttonComponent);
Vue.use(checkboxComponent);
Vue.use(phoneNumberInputComponent);
Vue.use(dadataComponent);
Vue.use(initDialogPlugin);
Vue.use(loaderComponent);
